export default __webpack_public_path__ + "static/media/delivery.a0418ea9.png";